/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'
import { GROUP_FRAGMENT } from '../fragments'

export const UPDATE_GROUP = gql`
  mutation UpdateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      success
      message
      group {
        ...Group
      }
    }
  }
  ${GROUP_FRAGMENT}
`
